import React from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

export interface DispatchFiltersProps {
  filters: {
    start: string;
    end: string;
    status: string;
    ticket_id: string;
    assignee: string;
  };
  onChange: (key: string, value: string | boolean | null) => void;
  onReset: () => void;
}

const STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'succeeded', label: 'Succeeded' },
  { value: 'failed', label: 'Failed' },
  { value: 'running', label: 'Running' },
  { value: 'partial', label: 'Partial' },
];

const DispatchFilters: React.FC<DispatchFiltersProps> = ({
  filters,
  onChange,
  onReset,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <TextField
            size="small"
            label="Start Date"
            type="date"
            value={filters.start}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('start', e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 160 }}
          />
        </Grid>
        <Grid item>
          <TextField
            size="small"
            label="End Date"
            type="date"
            value={filters.end}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('end', e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 160 }}
          />
        </Grid>
        <Grid item>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status}
              label="Status"
              onChange={(e: { target: { value: string } }) => onChange('status', e.target.value)}
            >
              {STATUS_OPTIONS.map((opt) => (
                <MenuItem key={opt.value || 'all'} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <TextField
            size="small"
            label="Assignee"
            value={filters.assignee}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('assignee', e.target.value)}
            placeholder="Filter by assignee"
            sx={{ width: 140 }}
          />
        </Grid>
        <Grid item>
          <TextField
            size="small"
            label="Ticket ID"
            value={filters.ticket_id}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('ticket_id', e.target.value)}
            placeholder="Ticket ID"
            type="number"
            sx={{ width: 100 }}
          />
        </Grid>
        <Grid item xs />
        <Grid item>
          <Button variant="outlined" onClick={onReset}>
            Reset
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DispatchFilters;
